import DatePicker from 'react-datepicker'
import React, {useRef} from "react";
import ShowCalendar from "@/components/common/GenericDatePicker/ShowCalendar";

interface GenericMultiDatePickerProps {
  startDate: Date | null
  endDate: Date | null
  onChange: Function
}

const GenericMultiDatePicker: React.FC<GenericMultiDatePickerProps>
  = ({ startDate, endDate, onChange }) => {
  const inputRef = useRef(null)
  return <DatePicker
    isClearable
    selectsRange
    selected={startDate}
    startDate={startDate}
    endDate={endDate}
    onChange={onChange}
    customInput={<ShowCalendar ref={inputRef}/>}
  />
}




export default GenericMultiDatePicker;
